import { render } from "./EventList.vue?vue&type=template&id=0b02d430&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=0b02d430&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b02d430"

export default script